import ConfirmationModal from '../ConfirmationModal'
import { Dropdown, Image } from 'react-bootstrap'
import { CaretDown, Gear, SignOut, UserCircle } from 'phosphor-react'
import { useAuth } from '../../hooks/AuthContext'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import styles from './styles.module.css'

function ProfileInfo({ user, userCircleColor = 'black' }) {
  const [showModal, setShowModal] = useState(false)

  const { signOut, authData } = useAuth()
  const handleSignOut = () => {
    try {
      signOut()
      setShowModal(false)
      navigate('/login')
      toast.success('Até breve! 🙂')
    } catch (error) {
      toast.error('Falha ao sair. Tente novamente.')
    }
  }

  const navigate = useNavigate()

  const roleUrl = () => {
    switch (authData.role) {
      case 'company':
        return 'empresa'
      case 'manager':
        return 'gestor-entregas'
      case 'attendant':
        return 'atendente'
      case 'admin':
        return 'admin'
      default:
        return ''
    }
  }

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle id="dropdown-basic" className={styles.toggleBtn}>
          {user && user.profile_picture ? (
            <Image
              src={user.profile_picture.url}
              style={{
                height: 40,
                width: 40,
                borderRadius: 50,
                objectFit: 'cover',
                objectPosition: 'center center',
              }}
            />
          ) : (
            <UserCircle color={userCircleColor} size={40} />
          )}
          <CaretDown size={16} color={userCircleColor} style={{ marginLeft: 5, marginRight: 6 }} />
        </Dropdown.Toggle>
        <Dropdown.Menu style={{ maxWidth: 300 }}>
          <Dropdown.Header className={styles.header}>
            <div>
              <p style={{ margin: 0 }}>
                Olá, {authData.role === 'company' ? user.brand_name : user.name}!
              </p>
            </div>
          </Dropdown.Header>
          <Dropdown.Divider />
          <Dropdown.Item
            onClick={() => navigate(`/${roleUrl()}/editar`)}
            className={styles.dropdownItem}
          >
            <Gear size={16} color="#053C5E" />
            Configurações
          </Dropdown.Item>
          <Dropdown.Item onClick={() => setShowModal(true)} className={styles.dropdownItem}>
            <SignOut size={16} color="#053C5E" />
            <div>Sair</div>
          </Dropdown.Item>
        </Dropdown.Menu>

        <ConfirmationModal
          show={showModal}
          message="Tem certeza de que deseja sair?"
          action={handleSignOut}
          closeModal={() => setShowModal(false)}
          onHide={() => setShowModal(false)}
        ></ConfirmationModal>
      </Dropdown>
    </>
  )
}

export default ProfileInfo
